import type { DSSetup } from 'webapp-types';

import type { Args as BaseArgs } from 'webapp/components/common/master-filter';
import CommonMasterFilterComponent from 'webapp/components/common/master-filter';

import type { BlockState } from 'webapp/models-custom';
import type { MasterMetricSetup } from 'webapp/models-custom/board-state';

interface Args extends BaseArgs {
	blockState: BlockState;
	trackingOrigin?: string;
	updateIsActive?: (active: boolean) => void;
}

export default class BlockMasterFilterComponent extends CommonMasterFilterComponent<Args> {
	origin = this.args.trackingOrigin ?? 'block';

	get block() {
		// read changes from block, not blockstate
		// bcos blockstate only keeps unsaved
		return this.args.blockState.block;
	}

	get blockMetricSetupChanges() {
		return this.block.changes?.metricSetup as MasterMetricSetup | undefined;
	}

	get dimensions(): string[] | undefined {
		return this.blockMetricSetupChanges?.dimensions;
	}

	get filters(): DSSetup.MetricSetupFiltersData | null | undefined {
		return this.blockMetricSetupChanges?.filters;
	}

	get metricDataItems(): DSSetup.MetricData[] {
		return this.args.blockState.metricData;
	}

	get metricSetupDataItems(): DSSetup.MetricSetupData[] {
		return this.args.blockState.metricSetupDataArray;
	}

	get allowAdvancedSetup(): boolean {
		return this.metricSetup.allowDimensions && this.args.blockState.allowAdvancedSetup;
	}

	get allowAdvancedFilters(): boolean {
		return this.metricSetup.allowDimensions && this.args.blockState.allowAdvancedFilters;
	}

	protected override onIsPopupOpenChange() {
		super.onIsPopupOpenChange();
		this.args.updateIsActive?.(this.isPopupOpen);
	}
}
